export enum GpmType {
  Fixed,
  Range,
}

export type FixedGpm = {
  type: GpmType;
  fixed: number;
};

export type RangeGpm = {
  type: GpmType;
  lower: number;
  upper: number;
};

export type Gpm = FixedGpm | RangeGpm | null;

export function isRangeGpm(gpm: Gpm | number): gpm is RangeGpm {
  if (typeof gpm === "number") {
    return false;
  }
  return gpm?.type === GpmType.Range;
}
